// @ts-nocheck
// import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
// import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import * as React from "react";
// import { connect } from "react-redux";
// import { css } from "styled-components";

/* Store Custom Code */
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import OrderView from "@store/Library/Components/OrderView";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";

const OrderDate = getWidgetComponent("OrderDetails/OrderDate");
const RequestedDate = getWidgetComponent("OrderDetails/OrderDetailsRequestedDate");
const OrderSalesperson = getWidgetComponent("OrderDetails/OrderSalesperson");
const Status = getWidgetComponent("OrderDetails/OrderDetailsStatus");
const OrderPo = getWidgetComponent("OrderDetails/OrderPo");
const PaymentTerms = getWidgetComponent("OrderDetails/OrderDetailsPaymentTerms");
const ShippingAddress = getWidgetComponent("OrderDetails/OrderDetailsShippingAddress");
const VatNumber = getWidgetComponent("OrderDetails/OrderDetailsVatNumber");
const ShippingMethod = getWidgetComponent("OrderDetails/OrderDetailsShippingMethod");
const BillingAddress = getWidgetComponent("OrderDetails/OrderDetailsBillingAddress");
const Notes = getWidgetComponent("OrderDetails/OrderDetailsNotes");
const ShipmentPackages = getWidgetComponent("OrderDetails/OrderDetailsShipmentPackages");
const Total = getWidgetComponent("OrderDetails/OrderDetailsTotal");
const SummaryTable = getWidgetComponent("OrderDetails/OrderDetailsSummaryTable");

/* Absolunet Custom Code */

const OrderDetailsView: React.FC<WidgetProps> = props => {
    const { value: order } = React.useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    return (
        <OrderView
            order={order}
            OrderDate={<OrderDate />}
            RequestedDate={<RequestedDate />}
            ShippingMethod={<ShippingMethod />}
            OrderSalesperson={<OrderSalesperson />}
            Status={<Status />}
            OrderPo={<OrderPo />}
            PaymentTerms={<PaymentTerms />}
            VatNumber={<VatNumber />}
            ShippingAddress={<ShippingAddress />}
            BillingAddress={<BillingAddress />}
            ShipmentPackages={<ShipmentPackages />}
            Total={<Total />}
            Notes={<Notes />}
            SummaryTable={<SummaryTable />}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsView,
    definition: {
        displayName: "Order Details View",
        allowedContexts: ["OrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
